import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqData = [
    {
      q: '星球漫画是否完全免费？',
      a: '是的，星球漫画上的所有漫画内容均免费提供给读者阅读。我们致力于为中文读者打造一个优质的在线漫画平台，所有星际漫画、科幻漫画和宇宙漫画均无需付费。',
    },
    {
      q: '漫画更新频率如何？',
      a: '我们大部分热门漫画保持每周更新，部分作品为双周更新。您可以通过订阅我们的新闻通讯，第一时间获取最新科幻漫画的更新通知。',
    },
    {
      q: '如何在手机上阅读漫画？',
      a: '星球漫画网站已针对移动端进行优化，您可以直接在手机浏览器中访问我们的网站，享受流畅的下拉式阅读体验，无需下载任何App。',
    },
    {
      q: '可以下载漫画离线阅读吗？',
      a: '为保护作者版权，目前暂不支持漫画下载功能。但我们提供了流畅的在线阅读体验和书签功能，方便您随时继续阅读。',
    },
    {
      q: '如何联系星球漫画团队？',
      a: '您可以通过邮件 contact@xingqiumanhua.com 联系我们，或关注我们的微信公众号"星球漫画"获取最新动态。我们非常乐意听取读者的意见和建议。',
    },
  ];

  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '星球漫画',
          url: 'https://yzdaohc.cn',
          description: '星球漫画 - 星际科幻漫画宇宙漫画大全，提供免费在线漫画阅读',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@xingqiumanhua.com',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
          address: {
            '@type': 'PostalAddress',
            addressLocality: '北京',
            addressCountry: 'CN',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 星球漫画',
          description: '了解星球漫画品牌故事、发展历程与联系方式',
          url: 'https://yzdaohc.cn/about',
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.a,
            },
          })),
        }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-6 mb-16">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于<strong>星球漫画</strong>
            </h1>
            <p className="text-sm text-foreground-500 max-w-2xl">
              星球漫画是一个专注于星际科幻类漫画的中文在线阅读平台，致力于为读者提供最优质的科幻漫画阅读体验。
            </p>
          </section>

          <section className="mb-16">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="flex-1">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">
                  品牌<strong>故事</strong>
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    星球漫画创立于2020年，由一群热爱科幻漫画的创作者和工程师共同打造。我们的使命是建立一个高质量的中文在线漫画平台，让每一位<strong>科幻漫画</strong>爱好者都能轻松找到并阅读自己喜爱的作品。
                  </p>
                  <p>
                    在星球漫画，我们精心筛选了涵盖<strong>星际漫画</strong>、<strong>宇宙漫画</strong>、星球大战漫画、太空冒险漫画等多种类型的优质作品。我们与众多优秀的漫画作者合作，持续为读者带来新鲜、精彩的原创内容。
                  </p>
                  <p>
                    我们的阅读器采用下拉式设计，让读者可以像浏览网页一样自然地阅读漫画，无需翻页等待。这种流畅的阅读体验是星球漫画区别于传统漫画平台的核心特色之一。
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20workspace%20with%20digital%20drawing%20tablets%2C%20comic%20art%20on%20walls%2C%20warm%20ambient%20lighting%2C%20minimal%20design%2C%20clean%20and%20tidy%2C%20orange%20and%20teal%20decor%20accents%2C%20peaceful%20atmosphere&width=600&height=400&seq=about-brand&orientation=landscape"
                  alt="星球漫画品牌故事"
                  title="星球漫画 - 品牌故事"
                  className="w-full max-w-md rounded-lg object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              发展<strong>历程</strong>
            </h2>
            <div className="max-w-2xl mx-auto">
              {[
                { year: '2020', title: '星球漫画上线', desc: '平台正式上线，首批收录500+部星际科幻漫画，开启免费在线漫画阅读服务。' },
                { year: '2021', title: '阅读体验升级', desc: '推出下拉式阅读模式，大幅提升移动端阅读体验，用户数量突破100万。' },
                { year: '2022', title: '内容生态建设', desc: '与50+位原创漫画作者达成合作，开启原创科幻漫画扶持计划，丰富宇宙漫画内容库。' },
                { year: '2023', title: '社区功能上线', desc: '推出评论区、收藏夹和阅读记录功能，打造读者互动社区，平台月活用户突破500万。' },
                { year: '2024', title: '技术全面升级', desc: '采用全新前端架构，页面加载速度提升300%，为用户提供更流畅的在线漫画阅读体验。' },
                { year: '2025', title: '内容突破万部', desc: '平台收录漫画作品突破10000部，成为中文科幻漫画领域的领先平台。' },
                { year: '2026', title: 'AI推荐系统', desc: '引入智能推荐算法，根据读者偏好精准推荐好看的漫画，用户满意度大幅提升。' },
              ].map((item, index) => (
                <div key={index} className="flex gap-6 pb-8 relative">
                  {index < 6 && (
                    <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-200"></div>
                  )}
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-bold text-sm z-10">
                    {item.year.slice(2)}
                  </div>
                  <div className="pt-1.5">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                      {item.year} · {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              读者<strong>口碑</strong>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { name: '星际探险家', content: '星球漫画是我每天必刷的漫画网站！星际漫画的种类特别全，下拉式阅读体验真的超级棒，比翻页舒服太多了。推荐给所有科幻迷！', rating: 5 },
                { name: '宇宙漫步者', content: '在这里找到了好多冷门但超好看的太空漫画，更新速度也很快。界面简洁干净，没有乱七八糟的广告，阅读体验一流。', rating: 5 },
                { name: '科幻迷小明', content: '作为一个重度科幻漫画爱好者，星球漫画的推荐算法真的很精准，总能推给我感兴趣的新作品。作者大大们的原创内容质量也越来越高了！', rating: 5 },
                { name: '漫画少女', content: '虽然是科幻漫画平台，但也有很多融合了浪漫元素的作品，比如群星之间就超级好看！免费阅读真的良心，已经推荐给身边所有朋友了。', rating: 4 },
                { name: '星空守望者', content: '下拉式阅读真的是革命性的体验！在手机上看起来特别流畅。收藏夹功能也很好用，追更神器！希望继续增加更多宇宙漫画。', rating: 5 },
                { name: '银河旅行者', content: '从2022年开始用星球漫画，见证了平台的不断成长。现在的AI推荐真的很厉害，帮我发现了好多之前错过的好作品。星球大战漫画系列太燃了！', rating: 5 },
              ].map((review, index) => (
                <div key={index} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        {i < review.rating ? (
                          <i className="ri-star-fill text-amber-400 text-xs"></i>
                        ) : (
                          <i className="ri-star-line text-amber-400 text-xs"></i>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">&ldquo;{review.content}&rdquo;</p>
                  <p className="text-xs text-foreground-400 font-medium">— {review.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              联系<strong>我们</strong>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">contact@xingqiumanhua.com</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-500">星球漫画</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">办公地址</h3>
                <p className="text-xs text-foreground-500">中国·北京</p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              常见<strong>问题</strong>
            </h2>
            <div className="max-w-2xl mx-auto space-y-3">
              {faqData.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-lg">
                  <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                    <h3 className="text-sm font-medium text-foreground-800 pr-4">{item.q}</h3>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </div>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}